export enum ArchiveVolumeType {
  WBS = 'WBS',
  MATERIAL = 'MATERIAL',
  REGULAR = 'REGULAR',
}
